"use client";

import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
import { useEffect } from "react";
import { META_PIXEL_ID, META_PIXEL_READY_EVENT, trackMetaPageViewOnce, whenMetaPixelReady } from "@/utils/tracking/metaPixel";

// Rendered only with advertising consent (MarketingTags). If consent arrives
// mid-visit, this mounts then: the pixel initialises and sends PageView once.
export default function MetaPixel(t0) {
  const $ = _c(4);
  const {
    pageViewEventId
  } = t0;
  let t1;
  let t2;
  if ($[0] !== pageViewEventId) {
    t1 = () => whenMetaPixelReady(() => trackMetaPageViewOnce(pageViewEventId));
    t2 = [pageViewEventId];
    $[0] = pageViewEventId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Script id="facebook-pixel" strategy="afterInteractive">{`
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${META_PIXEL_ID}');
    window.__guestGalleryMetaPixelReady = true;
    window.dispatchEvent(new Event('${META_PIXEL_READY_EVENT}'));
  `}</Script>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}